import React from 'react';
import {
  Container,
  Button,
  Card,
  Form,
  Row,
  Col,
  Spinner,
  Accordion,
} from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import ProfilesRequestService from '../../services/profiles-request';
import { ProfileType } from '../../helpers/Enum/index';
import { AssignmentIndOutlined, ArrowBackOutlined } from '@material-ui/icons';
import Swal from 'sweetalert2';
import Alert from '../../helpers/alert';
import { useParams, useHistory } from 'react-router-dom';
import Loading from 'components/Loading';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css';

export default function() {
  const searchParams = {
    embed: 'routes|type|steps',
    fields: 'id,name,profile_type_id'
  }

  const [isLoad, setLoad] = useState(false);

  const [profile, setProfile] = useState({});
  const [name, setName] = useState('');
  const [type, setType] = useState('')
  const [profileTypes, setProfileTypes] = useState([]);
  const [flows, setFlows] = useState([]);
  const [steps, setSteps] = useState([]);
  const [routes, setRoutes] = useState([]);

  const [routeGroups, setRouteGroups] = useState([]);

  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    getProfileType();
    getFlows();
    getRoutes();
    if (id) {
      getProfile();
    }
  }, []);

  const getProfileType = () => {
    setProfileTypes(
      Object.keys(ProfileType).map((a) => {
        return { id: ProfileType[a], name: a };
      })
    );
  };

  const getProfile = () => {
    setLoad(true);
    const response = ProfilesRequestService.getOne(id, { 
      params: {...searchParams}
    });

    response.then(({ data }) => {
      setProfile(data);
      setName(data.name);
      setType(data.profile_type_id)
      setRoutes(data.routes.map(r => r.id));
      setSteps(data.steps.map((s) => s.id))
    }).finally(() => setLoad(false))
  };

  const getFlows = () => {
    let request = ProfilesRequestService.getFlows();
    request.then((data) => {
      setFlows(data.data.data);
    });
  };

  const getRoutes = () => {
    let request = ProfilesRequestService.getRouteGroups();
    request.then((data) => {
      setRouteGroups(data.data.data);
    });
  };

  const createFlow = () => {
    return (
      <>
        {flows.map((flow, k) => {
          return (
            <Col key={k}>
              <Form.Label>{flow.name}</Form.Label>
              {flow.steps.map((step, k) => {
                if (step.action_status) {
                  return (
                    <Form.Check
                      key={k}
                      label={step.action_status.name}
                      checked={steps.indexOf(step.id) !== -1}
                      onChange={(e) => {
                        let steps_aux = [...steps];
                        if (e.target.checked) steps_aux.push(step.id);
                        else steps_aux.splice(steps_aux.indexOf(step.id), 1);
                        setSteps([...steps_aux]);
                      }}
                    />
                  );
                }
              })}
            </Col>
          );
        })}
      </>
    );
  };

  function NewCheckBox({ state, onChange }) {
    const indetSetter = React.useCallback(
      (el) => {
        if (el && state() === 2) {
          el.indeterminate = true;
        }
      },
      [state]
    );
    return (
      <input
        type="checkbox"
        checked={state() === 1}
        ref={indetSetter}
        onClick={onChange}
      />
    );
  }

  const createRoutes = () => {
    return (
      <Accordion className="w-100 m-1">
        {routeGroups.map((group, k) => {
          return (
            <Card key={k}>
              <Card.Header className="row justify-content-between">
                <Col xs="auto">
                  <Accordion.Toggle eventKey={k + 1} as={Button} variant="link">
                    {group.name.toUpperCase()}
                  </Accordion.Toggle>
                </Col>
                <Col xs="auto" className="align-self-end">
                  <NewCheckBox
                    state={() => {
                      if (
                        group.routes.filter(
                          (r) => routes.indexOf(r.id) !== -1
                        ).length === group.routes.length
                      )
                        return 1;
                      else if (
                        group.routes.filter(
                          (r) => routes.indexOf(r.id) !== -1
                        ).length === 0
                      )
                        return 0;
                      else return 2;
                    }}
                    onChange={(e) => {
                      let routes_aux = [...routes];
                      group.routes.forEach((r) => {
                        if (routes_aux.indexOf(r.id) === -1 && e.target.checked)
                          routes_aux.push(r.id);
                        
                        if (routes_aux.indexOf(r.id) !== -1 && !e.target.checked)
                          routes_aux.splice(routes_aux.indexOf(r.id), 1);
                      });
                      setRoutes([...routes_aux]);
                    }}
                  />
                </Col>
              </Card.Header>
              <Accordion.Collapse eventKey={k + 1}>
                <Card.Body>
                  {group.routes.map((route, k) => {
                    return (
                      <Row
                        key={k}
                        className="line-group justify-content-between"
                      >
                        <Col className="pl-2 pr-0">
                          <span
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: '100%',
                              display: 'inline-block',
                            }}
                          >
                            {route.name.toUpperCase()}
                          </span>
                        </Col>
                        <Col xs="auto" className="align-self-end pl-0 pr-2">
                          <Form.Check
                            checked={routes.indexOf(route.id) !== -1}
                            onChange={(e) => {
                              let routes_aux = [...routes];
                              if (e.target.checked) 
                                routes_aux.push(route.id);
                              else
                                routes_aux.splice(routes_aux.indexOf(route.id), 1);

                              setRoutes([...routes_aux]);
                            }}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    );
  };

  const submit = () => {
    setLoad(true)
    const formData = new FormData()
    formData.append('name', name)
    formData.append('profile_type_id', type)
    routes.forEach((r, i) => formData.append(`routes[${i}]`, r))
    steps.forEach((s, i) => formData.append(`steps[${i}]`, s))

    if (id) {
      formData.append('_method', 'put')
      ProfilesRequestService
        .update(id, formData)
        .then(() => showAlertSuccess(id))
        .finally(() => setLoad(false))
    } else {
      ProfilesRequestService
        .save(formData)
        .then(() => showAlertSuccess())
        .finally(() => setLoad(false))
    }
  };

  const showAlertSuccess = (id = null) => {
    let message = id 
      ? "Perfil atualizado." 
      : "Perfil Criado.";

    setLoad(false);

    Alert.success(message)
    .then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        history.push('/profiles')
      }
    })
  }

  const getValue = (name) => {
    return profile[name] ? profile[name] : '';
  };

  const setValue = (name, value) => {
    let profile_aux = { ...profile };
    profile_aux[name] = value;
    setProfile({ ...profile_aux });
  };

  const minWidth = 500;
  const isMobile = window.innerWidth <= minWidth;

  return (
    <>
      <Container>
        <Row className="mt-4">
          <Button variant="link" onClick={() => {
            history.goBack()
          }}>
            <ArrowBackOutlined /> Voltar
          </Button>
        </Row>
        <Row className="mt-4">
          <AssignmentIndOutlined className="icon-title col-auto p-0" />
          <h5 className="title-dashboard col-10 p-0">
            Perfil {name ? '-' + name : '- Criar'}
          </h5>
        </Row>
        <Row>
          <Card.Body
            className={
              'card-dashboard shadow bg-white rounded text-left m-2 ' +
              (isMobile ? 'p-3' : 'p-5')
            }
          >
            {isLoad ? (<Loading page/> ) : (<>
            <Form>
              <Row>
                <Col md="12">
                  <h6 className="title-dashboard">Dados</h6>
                </Col>
                <Col md="12">
                  <hr className="line"></hr>
                </Col>
              </Row>
              <Row>
                <Col xl="6">
                  <Form.Group>
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      as="input"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xl="6">
                  <Form.Group>
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control
                      as="select"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option selected disabled>Selecione o Tipo</option>
                      {profileTypes.map((type, k) => (
                        <option key={k} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
            <Form>
              <Row>
                <Col md="12">
                  <h6 className="title-dashboard">Fluxo</h6>
                </Col>
                <Col md="12">
                  <hr className="line"></hr>
                </Col>
              </Row>
              <Row>{createFlow()}</Row>
            </Form>
            <Form>
              <Row className="mt-4">
                <Col md="12">
                  <h6 className="title-dashboard">Rotas</h6>
                </Col>
                <Col md="12">
                  <hr className="line"></hr>
                </Col>
              </Row>
              <Row>{createRoutes()}</Row>
            </Form>
            <Row className="mt-4 pl-2">
              {isLoad ? (
                <Spinner animation="border" style={{ color: '#e05c17' }} />
              ) : (
                <Button onClick={() => submit()}>Salvar</Button>
              )}
            </Row>
            </>)}
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
